import React from 'react';
import './analyticsAsk.css';

// Pure module — NO context/service imports (statically testable in this no-jsdom workspace).

/** `{kind:'clarify'}` — one server-authored question + server-authored option chips (label
 *  rendered verbatim; never model text; option bodies are opaque — passed to onPick WHOLE,
 *  never re-shaped here, so a scope/entity clarify's `scope`/`grain` fields survive the pick).
 *  A chip tap posts /metric directly — no second LLM call, one round max.
 *
 *  No client-side cap on `options.length`: each clarify AUTHOR already bounds its own set —
 *  clarifyOptions.js's metric-ambiguity clarify slices to 3 server-side, scopeClarify.js's
 *  scope/entity clarify offers up to 11 (10 largest groups + "Whole organisation", Task 8,
 *  #1661/#1663/#1664) — so re-capping here would truncate a legitimate, already-bounded scope
 *  choice (gemini/codex-reviewed: the server, not this component, owns "how many is too many").
 *  `note` (Phase 2 Task 8/#1664) — e.g. "Showing your 10 largest groups of N" or the fixed-14-day
 *  stuck-signal disclosure — renders verbatim below the chips, same convention as ComparisonCard's
 *  note and AnswerCard's plain_english: server copy, never recomposed here. */
export default function ClarifyCard({ question, options = [], note, onPick }) {
  return (
    <div className="aa-clarify">
      <p className="aa-clarify__question">{question}</p>
      <div className="aa-clarify__options">
        {options.map((opt) => (
          <button key={opt.label} type="button" className="aa-chip aa-chip--clarify" onClick={() => onPick?.(opt)}>
            {opt.label}
          </button>
        ))}
      </div>
      {note && <p className="aa-clarify__note">{note}</p>}
    </div>
  );
}
